export default "__VITE_ASSET__D3BKLX1i__"